import { SendOtpBodyChannel, SendOtpBodyLocale } from '@api/models';

import type { OtpChannel } from '@domain/models/otp';
import { ApiClient } from '@website/lib/api';

export async function sendOtp(phoneNumber: string, locale?: string, channel: OtpChannel = 'sms') {
  return ApiClient.sendOtp({
    phoneNumber,
    locale: locale === 'en' ? SendOtpBodyLocale.en : SendOtpBodyLocale.fr,
    channel: channel === 'call' ? SendOtpBodyChannel.call : SendOtpBodyChannel.sms
  });
}

export async function verifyOtp(phoneNumber: string, code: string) {
  return ApiClient.verifyOtp({ phoneNumber, code });
}

export async function getOtpSendStatus(sendId: string, signal?: AbortSignal) {
  return ApiClient.getOtpSendStatus(sendId, { signal });
}
